import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M7 10l5 5 5-5z" />, 'ArrowDropDown');
